import React, { useCallback, useState } from "react";

import * as INFO_TYPE from "2g-constants/informationTypes";
import PageHeading from "2g-page-heading";

import ZadostiGroupsContent from "b2b/components/zadosti-groups/ZadostiGroupsContent";
import data from "b2b-devel/zadosti/sumar.json";

export function ZadostiGroupsExample() {
  const [activeItem, setActiveItem] = useState();
  const onClick = useCallback(item => {
    setActiveItem(item);
  }, []);

  return (
    <>
      <div data-testid="test-zadostiGroupsContent-danger">
        <PageHeading>ZadostiGroupsContent - danger</PageHeading>
        <ZadostiGroupsContent
          data={data}
          onChange={onClick}
          type={INFO_TYPE.DANGER}
          value={activeItem}
        />
      </div>
      <div data-testid="test-zadostiGroupsContent-success">
        <PageHeading>ZadostiGroupsContent - success</PageHeading>
        <ZadostiGroupsContent
          data={data}
          onChange={onClick}
          showAll={true}
          type={INFO_TYPE.SUCCESS}
          value={activeItem}
        />
      </div>
      <div data-testid="test-zadostiGroupsContent-loading">
        <PageHeading>ZadostiGroupsContent - loading</PageHeading>
        <ZadostiGroupsContent
          data={data}
          loading={true}
          onChange={onClick}
          showAll={true}
          type={INFO_TYPE.SUCCESS}
        />
      </div>
      <div data-testid="test-zadostiGroupsContent-zero">
        <PageHeading>ZadostiGroupsContent - zero count</PageHeading>
        <ZadostiGroupsContent
          loaded
          data={[
            {
              typZdroje: {
                name: "ZEL_INFRASTUKTURA",
                vyznamCs: "Žel.infrastruktura",
                popisCs: "Železniční infrastruktura",
                vyznamEn: "Railway infrastructure",
                popisEn: "Railway infrastructure"
              },
              zdroje: [
                {
                  datumOd: "06.03.2023",
                  datumDo: "12.03.2023",
                  zdroj: {
                    id: 1,
                    nazevCs: "VZO",
                    popisCs: "Velký zkušení okruh",
                    nazevEn: "LTR",
                    popisEn: "Large test ring",
                    exkluzivita: true,
                    pozadavekSmena: true
                  },
                  stav: "PRIJATY",
                  pocet: 0
                }
              ]
            }
          ]}
          onChange={onClick}
          showAll={true}
          type={INFO_TYPE.SUCCESS}
        />
      </div>
      <div data-testid="test-zadostiGroupsContent-empty">
        <PageHeading>ZadostiGroupsContent - empty</PageHeading>
        <ZadostiGroupsContent
          loaded
          data={[]}
          onChange={onClick}
          showAll={true}
          type={INFO_TYPE.SUCCESS}
        />
      </div>
      <div data-testid="test-zadostiGroupsContent-error">
        <PageHeading>ZadostiGroupsContent - error</PageHeading>
        <ZadostiGroupsContent
          loaded
          data={[]}
          error={"chybička"}
          onChange={onClick}
          showAll={true}
          type={INFO_TYPE.SUCCESS}
        />
      </div>
    </>
  );
}

export default React.memo(ZadostiGroupsExample);
